import { Divider, Flex } from "antd";
import React, { Component } from "react";

export class MyApplicationModal extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.MyApplicationModal = this;
  }
  render() {
    let { props } = this;
    let { id, title, show, onClose, modalSize, emiData, emiColumns, editdata } =
      props;
    let attrs = Object.except(props, ["id", "title", "type", "onClose"]);

    return (
      <AppCanvas
        id={id}
        title={title}
        show={show}
        onClose={onClose}
        modalSize={modalSize}
      >
        <AppFormData {...attrs} onClose={onClose}></AppFormData>
        {editdata?.sanctionedRepayType === "EMI" && (
          <>
            <Divider />
            <Flex gap="small" className="mb-4">
              <div class="obligation_banner small">
                <p class="">
                  Principal Amount Disbursed : Rs.{" "}
                  <span>{editdata?.sanctionedLoanAmt?.cur()}</span>
                </p>
              </div>
              <div class="obligation_banner small">
                <p class="">
                  Total Interest : Rs.{" "}
                  <span>{editdata?.totalEmiInterest?.cur()}</span>
                </p>
              </div>
            </Flex>
            {emiData?.length > 0 && (
              <>
                {/* <h5 class="modal-title mb-3">Logs</h5> */}
                <AppTable
                  data={emiData || []}
                  columns={emiColumns}
                  reorder={true}
                  showPagination={false}
                  editable={false}
                  viewable={false}
                  deletable={false}
                ></AppTable>
              </>
            )}
          </>
        )}

        <div className="nav_container justify-content-end mt-4">
          <button
            type="button"
            className="btn btn-lg btn-primary-lite me-3"
            onClick={(...args) => props.handleCustomerApplRejection(...args)}
          >
            Reject
          </button>
          <button
            type="button"
            className="btn btn-lg btn-primary"
            onClick={(...args) => props.handleCustomerApplAccept(...args)}
          >
            Accept
          </button>
        </div>
      </AppCanvas>
    );
  }
}

export default MyApplicationModal;
